/* eslint-disable consistent-return */

import SimpleSchema from 'simpl-schema';

export default new SimpleSchema({
  ATTCP: {
    type: Array,
    label: 'The attitude angles of the sensor at the current position',
    optional: true
  },
  'ATTCP.$': {
    type: Number,
    label: 'The attitude angles of the sensor at the current position'
  },
  coordinates: {
    type: Array,
    label: 'The coordinates of the four projected corners of the sensor',
    optional: true
  },
  'coordinates.$': {
    type: Array,
    label: 'The coordinates of the four projected corners of the sensor'
  },
  'coordinates.$.$': {
    type: Number,
    label: 'The coordinates of the four projected corners of the sensor'
  },
  distanceTravelled: {
    type: Number,
    label: 'The travelled distance from the start point'
  },
  GPSCPP: {
    type: Array,
    label: 'The coordinates of the projected projection center',
    optional: true
  },
  'GPSCPP.$': {
    type: Number,
    label: 'The coordinates of the projected projection center'
  },
  GPSHome: {
    type: Array,
    label: 'The coordinates of the take off point',
    optional: true
  },
  'GPSHome.$': {
    type: Number,
    label: 'The coordinates of the take off point'
  },
  HPN: {
    type: Number,
    label: 'The height of the nadiral point',
    optional: true
  },
  isControlPoint: {
    type: Boolean,
    label: 'Flag to check if the point is a control point for the synchronization'
  },
  timeUS: {
    type: Number,
    label: 'The corresponding time of the video'
  }
});
